import React from 'react';
import 'chart.js/auto';
import { Scatter } from 'react-chartjs-2'
import { Chart, Title } from "chart.js";

const ScatterChart = (props) => {
    Chart.register(Title);

    return (
        <div>
            <Scatter key={props.key} data={props.chartData}
                height={props.height}
                width={props.width}
                options={props.options}
            />
        </div>
    );
};

export default ScatterChart;
